import React from 'react';
import './Testimonials.css';

function Testimonials() {
  return (
  <section className="bg-secondary py-5">
  <div className="container py-2 py-md-3 py-lg-4 py-xl-5">
    <div className="row row-cols-1 row-cols-md-2 align-items-center justify-content-center">
      <div className="col-md-5 mb-3 mb-md-0">
     
           
            <h1 className=" display-5 fw-medium text-center text-sm-start">What Our Clients <br/> Say About Orbix</h1>
       
      </div>
      <div className="col-md-6">
        <div className="card border-0 shadow-sm p-4 p-xxl-5">
          <div className="d-flex justify-content-between pb-4 mb-2">
            <span className="btn btn-icon btn-primary btn-lg shadow-primary pe-none">
              <i className="bx bxs-quote-left"></i>
            </span>
            <div className="d-flex">
              <button type="button" id="testimonials-prev" className="btn btn-prev btn-icon btn-sm me-2">
                <i className="bx bx-chevron-left"></i>
              </button>
              <button type="button" id="testimonials-next" className="btn btn-next btn-icon btn-sm ms-2">
                <i className="bx bx-chevron-right"></i>
              </button>
            </div>
          </div>
          
          {/* Slider */}
          <div className="swiper mx-0 mb-md-n2 mb-xxl-n3" data-swiper-options='{
            "spaceBetween": 24,
            "loop": true,
            "pagination": {
              "el": ".swiper-pagination",
              "clickable": true
            },
            "navigation": {
              "prevEl": "#testimonials-prev",
              "nextEl": "#testimonials-next"
            }
          }'>
            <div className="swiper-wrapper">

              {/* Item */}
              <div className="swiper-slide h-auto">
                <figure className="card h-100 position-relative border-0 bg-transparent">
                  <blockquote className="card-body p-0 mb-0">
                    <p className="fs-lg mb-0">Orbix completely changed how we manage inspections. What used to take days of back-and-forth now happens instantly. Our teams in the field get answers right away, and management finally has full visibility into the process. It’s streamlined everything and given us confidence in the quality of our work.</p>
                  </blockquote>
                  <figcaption className="card-footer border-0 d-flex align-items-center w-100 pb-2">
                    
                    <div className="">
                      <h6 className="fw-semibold lh-base mb-0">Scott Elliott</h6>
                      <span className="fs-sm text-muted">President Prime NDT</span>
                    </div>
                  </figcaption>
                </figure>
              </div>

             

             
            </div>

            {/* Pagination (bullets) */}
            <div className="swiper-pagination position-relative mt-5"></div>
          </div>        
        </div>
      </div>
    </div>
  </div>
</section>
  );
}

export default Testimonials;

